"use client";

import type { SchoolData } from "@nimble/candidate-api/types";

import MobileSchoolDetailsView from "@/components/shared/school/school-details/mobile-school-details.view";
import { StateConfig } from "@/lib/states-config";

interface MobileSchoolDetailsContainerProps {
  schoolData: SchoolData;
  stateConfig: StateConfig;
  onClose?: () => void;
}

export default function MobileSchoolDetailsContainer({
  schoolData,
  stateConfig,
  onClose = () => {},
}: MobileSchoolDetailsContainerProps) {
  return (
    <MobileSchoolDetailsView
      school={schoolData}
      stateConfig={stateConfig}
      isOpen
      onClose={onClose}
    />
  );
}
